var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Education"},[_vm._v(" Bildung ")])
}
var staticRenderFns = []

export { render, staticRenderFns }